import axiosInstance from "./axiosInstance";

const dispenserPurchaseService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/dispenserSale/create', payload);
              console.log("API Response:", response);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
 };

export default dispenserPurchaseService;
